// Pushes to window.dataLayer and forwards key ecommerce events to Meta Pixel when loaded.
const PIXEL_EVENTS = { add_to_cart: 'AddToCart', checkout_started: 'InitiateCheckout', purchase: 'Purchase', flavour_selected: 'ViewContent' };

export function track(event, payload = {}) {
  const data = { event, ...payload, ts: Date.now() };
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
    const fb = PIXEL_EVENTS[event];
    if (fb && window.fbq) {
      const value = payload.total ?? payload.price ?? payload.value;
      window.fbq('track', fb, value != null ? { value: Number(value), currency: 'EUR' } : {});
    }
  } catch (e) { /* noop */ }
  if (typeof window !== 'undefined' && window.__SMAN_DEBUG__) {
    // eslint-disable-next-line no-console
    console.log('[analytics]', event, payload);
  }
}
